module.exports = __webpack_public_path__ + "img/ico_translate.d8843e92.svg";